"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRowTableRowAlignmentHistoryItem = exports.TableRowHeaderHistoryItem = exports.TableRowHideCellMarkHistoryItem = exports.TableRowCantSplitHistoryItem = exports.TableRowCellSpacingHistoryItem = exports.TableRowHeightHistoryItem = exports.TableRowPropertiesUseHistoryItemBase = exports.TableRowWidthBeforeHistoryItem = exports.TableRowWidthAfterHistoryItem = exports.TableRowGridBeforeHistoryItem = exports.TableRowGridAfterHistoryItem = exports.TableRowPropertiesHistoryItemBase = void 0;
var tslib_1 = require("tslib");
var errors_1 = require("@devexpress/utils/lib/errors");
var create_table_history_item_1 = require("./create-table-history-item");
var TableRowPropertiesHistoryItemBase = (function (_super) {
    tslib_1.__extends(TableRowPropertiesHistoryItemBase, _super);
    function TableRowPropertiesHistoryItemBase(modelManipulator, boundSubDocument, tableIndex, rowIndex, newValue) {
        var _this = _super.call(this, modelManipulator, boundSubDocument, tableIndex) || this;
        _this.newValue = newValue;
        _this.rowIndex = rowIndex;
        return _this;
    }
    return TableRowPropertiesHistoryItemBase;
}(create_table_history_item_1.TableBasedHistoryItem));
exports.TableRowPropertiesHistoryItemBase = TableRowPropertiesHistoryItemBase;
var TableRowGridAfterHistoryItem = (function (_super) {
    tslib_1.__extends(TableRowGridAfterHistoryItem, _super);
    function TableRowGridAfterHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableRowGridAfterHistoryItem.prototype.redo = function () {
        this.oldState = this.modelManipulator.table.rowProperties.gridAfter.setValue(this.boundSubDocument, this.tableIndex, this.rowIndex, this.newValue);
    };
    TableRowGridAfterHistoryItem.prototype.undo = function () {
        this.modelManipulator.table.rowProperties.gridAfter.restoreValue(this.boundSubDocument, this.oldState);
    };
    return TableRowGridAfterHistoryItem;
}(TableRowPropertiesHistoryItemBase));
exports.TableRowGridAfterHistoryItem = TableRowGridAfterHistoryItem;
var TableRowGridBeforeHistoryItem = (function (_super) {
    tslib_1.__extends(TableRowGridBeforeHistoryItem, _super);
    function TableRowGridBeforeHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableRowGridBeforeHistoryItem.prototype.redo = function () {
        this.oldState = this.modelManipulator.table.rowProperties.gridBefore.setValue(this.boundSubDocument, this.tableIndex, this.rowIndex, this.newValue);
    };
    TableRowGridBeforeHistoryItem.prototype.undo = function () {
        this.modelManipulator.table.rowProperties.gridBefore.restoreValue(this.boundSubDocument, this.oldState);
    };
    return TableRowGridBeforeHistoryItem;
}(TableRowPropertiesHistoryItemBase));
exports.TableRowGridBeforeHistoryItem = TableRowGridBeforeHistoryItem;
var TableRowWidthAfterHistoryItem = (function (_super) {
    tslib_1.__extends(TableRowWidthAfterHistoryItem, _super);
    function TableRowWidthAfterHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableRowWidthAfterHistoryItem.prototype.redo = function () {
        this.oldState = this.modelManipulator.table.rowProperties.widthAfter.setValue(this.boundSubDocument, this.tableIndex, this.rowIndex, this.newValue);
    };
    TableRowWidthAfterHistoryItem.prototype.undo = function () {
        this.modelManipulator.table.rowProperties.widthAfter.restoreValue(this.boundSubDocument, this.oldState);
    };
    return TableRowWidthAfterHistoryItem;
}(TableRowPropertiesHistoryItemBase));
exports.TableRowWidthAfterHistoryItem = TableRowWidthAfterHistoryItem;
var TableRowWidthBeforeHistoryItem = (function (_super) {
    tslib_1.__extends(TableRowWidthBeforeHistoryItem, _super);
    function TableRowWidthBeforeHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableRowWidthBeforeHistoryItem.prototype.redo = function () {
        this.oldState = this.modelManipulator.table.rowProperties.widthBefore.setValue(this.boundSubDocument, this.tableIndex, this.rowIndex, this.newValue);
    };
    TableRowWidthBeforeHistoryItem.prototype.undo = function () {
        this.modelManipulator.table.rowProperties.widthBefore.restoreValue(this.boundSubDocument, this.oldState);
    };
    return TableRowWidthBeforeHistoryItem;
}(TableRowPropertiesHistoryItemBase));
exports.TableRowWidthBeforeHistoryItem = TableRowWidthBeforeHistoryItem;
var TableRowPropertiesUseHistoryItemBase = (function (_super) {
    tslib_1.__extends(TableRowPropertiesUseHistoryItemBase, _super);
    function TableRowPropertiesUseHistoryItemBase(modelManipulator, boundSubDocument, tableIndex, rowIndex, newValues, newUse) {
        var _this = _super.call(this, modelManipulator, boundSubDocument, tableIndex, rowIndex, newValues) || this;
        _this.newUse = newUse;
        return _this;
    }
    TableRowPropertiesUseHistoryItemBase.prototype.redo = function () {
        this.oldState = this.getManipulator().setValue(this.boundSubDocument, this.tableIndex, this.rowIndex, this.newValue, this.newUse);
    };
    TableRowPropertiesUseHistoryItemBase.prototype.undo = function () {
        this.getManipulator().restoreValue(this.boundSubDocument, this.oldState);
    };
    TableRowPropertiesUseHistoryItemBase.prototype.getManipulator = function () {
        throw new Error(errors_1.Errors.NotImplemented);
    };
    return TableRowPropertiesUseHistoryItemBase;
}(TableRowPropertiesHistoryItemBase));
exports.TableRowPropertiesUseHistoryItemBase = TableRowPropertiesUseHistoryItemBase;
var TableRowHeightHistoryItem = (function (_super) {
    tslib_1.__extends(TableRowHeightHistoryItem, _super);
    function TableRowHeightHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableRowHeightHistoryItem.prototype.redo = function () {
        this.oldState = this.modelManipulator.table.rowProperties.height.setValue(this.boundSubDocument, this.tableIndex, this.rowIndex, this.newValue);
    };
    TableRowHeightHistoryItem.prototype.undo = function () {
        this.modelManipulator.table.rowProperties.height.restoreValue(this.boundSubDocument, this.oldState);
    };
    return TableRowHeightHistoryItem;
}(TableRowPropertiesHistoryItemBase));
exports.TableRowHeightHistoryItem = TableRowHeightHistoryItem;
var TableRowCellSpacingHistoryItem = (function (_super) {
    tslib_1.__extends(TableRowCellSpacingHistoryItem, _super);
    function TableRowCellSpacingHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableRowCellSpacingHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.table.rowProperties.cellSpacing;
    };
    return TableRowCellSpacingHistoryItem;
}(TableRowPropertiesUseHistoryItemBase));
exports.TableRowCellSpacingHistoryItem = TableRowCellSpacingHistoryItem;
var TableRowCantSplitHistoryItem = (function (_super) {
    tslib_1.__extends(TableRowCantSplitHistoryItem, _super);
    function TableRowCantSplitHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableRowCantSplitHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.table.rowProperties.cantSplit;
    };
    return TableRowCantSplitHistoryItem;
}(TableRowPropertiesUseHistoryItemBase));
exports.TableRowCantSplitHistoryItem = TableRowCantSplitHistoryItem;
var TableRowHideCellMarkHistoryItem = (function (_super) {
    tslib_1.__extends(TableRowHideCellMarkHistoryItem, _super);
    function TableRowHideCellMarkHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableRowHideCellMarkHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.table.rowProperties.hideCellMark;
    };
    return TableRowHideCellMarkHistoryItem;
}(TableRowPropertiesUseHistoryItemBase));
exports.TableRowHideCellMarkHistoryItem = TableRowHideCellMarkHistoryItem;
var TableRowHeaderHistoryItem = (function (_super) {
    tslib_1.__extends(TableRowHeaderHistoryItem, _super);
    function TableRowHeaderHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableRowHeaderHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.table.rowProperties.header;
    };
    return TableRowHeaderHistoryItem;
}(TableRowPropertiesUseHistoryItemBase));
exports.TableRowHeaderHistoryItem = TableRowHeaderHistoryItem;
var TableRowTableRowAlignmentHistoryItem = (function (_super) {
    tslib_1.__extends(TableRowTableRowAlignmentHistoryItem, _super);
    function TableRowTableRowAlignmentHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableRowTableRowAlignmentHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.table.rowProperties.tableRowAlignment;
    };
    return TableRowTableRowAlignmentHistoryItem;
}(TableRowPropertiesUseHistoryItemBase));
exports.TableRowTableRowAlignmentHistoryItem = TableRowTableRowAlignmentHistoryItem;
